// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CouponDetailStamp_wrap__Gfkev","shadowless":"CouponDetailStamp_shadowless__cLwVG"};